import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Cookies from 'js-cookie'
import API_BASE_URL from '../../../config/api'
import Topbar from '../mini-comp/Topbar'
import Sidebar from '../mini-comp/Sidebar'
import Swal from 'sweetalert2'
import { RiCameraFill } from 'react-icons/ri'
import { useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import ImageCropperModal from '../mini-comp/ImageCropperModal'

const CreateEmployee = () => {
    const navigate = useNavigate();
    const [departments, setDepartments] = useState([]);
    const [roles, setRoles] = useState([]);
    const [previewImage, setPreviewImage] = useState("/assets/images/avatar/avatar-thumb-dummy.png");
    const [photo, setPhoto] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [subscribedModules, setSubscribedModules] = useState([]);
    const [cropModalOpen, setCropModalOpen] = useState(false);
    const [rawImageSrc, setRawImageSrc] = useState(null);

    const [formData, setFormData] = useState({
        first_name: '',
        middle_name: '',
        last_name: '',
        id_number: '',
        email: '',
        phone_number: '',
        position: '',
        nssa_ssr_number: '',
        zimra_tin_number: '',
        department: '',
        gender: '',
        date_of_birth: '',
        home_address: '',
        marital_status: '',
        spouse_name: '',
        spouse_contact: '',

        next_of_kin_name: '',
        next_of_kin_contact: '',
        next_of_kin_relationship: '',
        next_of_kin_address: '',
        working_days_per_month: '',
        working_hours_per_day: '',
        bank_name: '',
        bank_branch: '',
        bank_account_number: '',
        initial_salary: '',
        vacation_leave_days: '',
        category: 'worker',
        role_obj: ''
    });

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const token = Cookies.get('token');

                // Fetch Departments
                const deptResponse = await axios.get(`${API_BASE_URL}/api/v1/employees/department/`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                setDepartments(deptResponse.data);

                // Fetch Roles
                const rolesResponse = await axios.get(`${API_BASE_URL}/api/v1/users/roles/`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                setRoles(rolesResponse.data);

                // Fetch Subscribed Modules from Cookie
                const modulesCookie = Cookies.get('subscribedModules');
                if (modulesCookie) {
                    try {
                        setSubscribedModules(JSON.parse(modulesCookie));
                    } catch (e) {
                        console.error('Error parsing modules cookie:', e);
                    }
                }
            } catch (error) {
                console.error('Error fetching initial data:', error);
            }
        };
        fetchInitialData();
    }, []);

    const hasModule = (moduleName) => {
        return subscribedModules.some(m =>
            (m.name || m.module_name || '').toLowerCase().includes(moduleName.toLowerCase())
        )
    }
    const isRestricted = hasModule('Payroll') || hasModule('Leave');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setRawImageSrc(reader.result);
            setCropModalOpen(true);
        };
        reader.readAsDataURL(file);
        e.target.value = '';
    };

    const handleCropComplete = (croppedFile, previewUrl) => {
        setPhoto(croppedFile);
        setPreviewImage(previewUrl);
        setCropModalOpen(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const token = Cookies.get('token');
        const data = new FormData();

        // Append all text fields
        Object.keys(formData).forEach(key => {
            data.append(key, formData[key]);
        });

        // Append photo if exists
        if (photo) {
            data.append('photo', photo);
        }

        // Age validation
        if (formData.date_of_birth) {
            const dob = new Date(formData.date_of_birth);
            const today = new Date();
            let age = today.getFullYear() - dob.getFullYear();
            const m = today.getMonth() - dob.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
                age--;
            }

            if (age < 16) {
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Age',
                    text: 'Employee must be at least 16 years old.'
                });
                return;
            }
        }

        try {
            await axios.post(`${API_BASE_URL}/api/v1/employees/`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Employee created successfully!',
                timer: 2000,
                showConfirmButton: false
            });

            setTimeout(() => navigate('/hr/all-employees'), 2000);
        } catch (error) {
            console.error('Error creating employee:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Failed to create employee. Please check all fields.'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div>
            <Topbar />
            <Sidebar />

            <div className="app-content-area">
                <div className="app-content-wrap">
                    <div className="container-fluid">
                        <div className="row fix">
                            <div className="col-xl-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h1 className="card-title fs-16">Add New Employee</h1>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        <div className="card-body">
                                            <div className="row gy-15">
                                                <div className="col-xl-12">
                                                    <div className="text-center mb-4">
                                                        <div className="avatar avatar-xxl radius-100 position-relative d-inline-block">
                                                            <img src={previewImage} alt="profile" id="profileImage" className="radius-100" style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                                                            <span className="rounded-pill bg-primary avatar-badge position-absolute bottom-0 end-0 p-2 cursor-pointer">
                                                                <input
                                                                    type="file"
                                                                    name="photo"
                                                                    className="position-absolute w-100 h-100 opacity-0 start-0 top-0 cursor-pointer"
                                                                    id="profileImageChange"
                                                                    onChange={handleImageChange}
                                                                    accept="image/*"
                                                                />
                                                                <RiCameraFill className="text-white" size={20} />
                                                            </span>
                                                        </div>
                                                        <span className="d-block fw-5 text-muted mt-2">Employee Image (click camera to crop)</span>
                                                    </div>
                                                </div>

                                                <div className="col-xl-4">
                                                    <label htmlFor="firstName" className="form-label">First Name <span className="text-danger">*</span></label>
                                                    <input type="text" name='first_name' className="form-control" id="firstName" placeholder="First Name" value={formData.first_name} onChange={handleChange} required />
                                                </div>
                                                {!isRestricted && (
                                                    <div className="col-xl-4">
                                                        <label htmlFor="middleName" className="form-label">Middle Name</label>
                                                        <input type="text" name='middle_name' className="form-control" id="middleName" placeholder="Middle Name" value={formData.middle_name} onChange={handleChange} />
                                                    </div>
                                                )}
                                                <div className="col-xl-4">
                                                    <label htmlFor="lastName" className="form-label">Last Name <span className="text-danger">*</span></label>
                                                    <input type="text" name='last_name' className="form-control" id="lastName" placeholder="Last Name" value={formData.last_name} onChange={handleChange} required />
                                                </div>

                                                <>

                                                    <div className="col-xl-4">
                                                        <label htmlFor="email" className="form-label">ID Number <span className="text-danger">*</span></label>
                                                        <input type="text" name='id_number' className="form-control" id="id_number" placeholder="ID Number" value={formData.id_number} onChange={handleChange} required />
                                                    </div>
                                                    <div className="col-xl-4">
                                                        <label htmlFor="email" className="form-label">Email <span className="text-danger">*</span></label>
                                                        <input type="email" name='email' className="form-control" id="email" placeholder="Employee Email" value={formData.email} onChange={handleChange} required />
                                                    </div>
                                                    <div className="col-xl-4">
                                                        <label htmlFor="phoneNumber" className="form-label">Phone Number <span className="text-danger">*</span></label>
                                                        <input type="text" name='phone_number' className="form-control" id="phoneNumber" placeholder="Phone number" value={formData.phone_number} onChange={handleChange} required />
                                                    </div>
                                                </>

                                                <div className="col-xl-4">
                                                    <label htmlFor="position" className="form-label">Position <span className="text-danger">*</span></label>
                                                    <input type="text" name='position' className="form-control" id="position" placeholder="Position" value={formData.position} onChange={handleChange} required />
                                                </div>
                                                <div className="col-xl-4">
                                                    <label htmlFor="nssa_ssr_number" className="form-label">SRR No. <span className="text-danger">*</span></label>
                                                    <input type="text" name='nssa_ssr_number' className="form-control" id="nssa_ssr_number" placeholder="SSR No." value={formData.nssa_ssr_number} onChange={handleChange} />
                                                </div>
                                                <div className="col-xl-4">
                                                    <label htmlFor="zimra_tin_number" className="form-label">TIN No. <span className="text-danger">*</span></label>
                                                    <input type="text" name='zimra_tin_number' className="form-control" id="position" placeholder="TIN No." value={formData.zimra_tin_number} onChange={handleChange} />
                                                </div>
                                                <div className="col-xl-4">
                                                    <label htmlFor="department" className="form-label">Department <span className="text-danger">*</span></label>
                                                    <select className="form-control" name="department" id="department" value={formData.department} onChange={handleChange} required>
                                                        <option value="">Select Department</option>
                                                        {departments.map(dept => (
                                                            <option key={dept.id} value={dept.id}>{dept.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-xl-4">
                                                    <label htmlFor="gender" className="form-label">Gender <span className="text-danger">*</span></label>
                                                    <select className="form-control" name="gender" id="gender" value={formData.gender} onChange={handleChange} required>
                                                        <option value="">Choose gender</option>
                                                        <option value="M">Male</option>
                                                        <option value="F">Female</option>
                                                    </select>
                                                </div>
                                                <div className="col-xl-4">
                                                    <label htmlFor="dateOfBirth" className="form-label">Date of Birth <span className="text-danger">*</span></label>
                                                    <input
                                                        type="date"
                                                        name='date_of_birth'
                                                        className="form-control"
                                                        id="dateOfBirth"
                                                        value={formData.date_of_birth}
                                                        onChange={handleChange}
                                                        max={(() => { const d = new Date(); d.setFullYear(d.getFullYear() - 18); return d.toISOString().split('T')[0]; })()}
                                                        required
                                                    />
                                                </div>

                                                {!isRestricted && (
                                                    <>
                                                        <div className="col-xl-4">
                                                            <label htmlFor="address" className="form-label">Home Address</label>
                                                            <textarea className="form-control" name='home_address' id="address" rows={3} placeholder="Home Address" value={formData.address} onChange={handleChange} />
                                                        </div>
                                                        <div className="col-xl-4">
                                                            <label htmlFor="maritalStatus" className="form-label">Marital Status <span className="text-danger">*</span></label>
                                                            <select className="form-control" name="marital_status" id="maritalStatus" value={formData.marital_status} onChange={handleChange} required>
                                                                <option value="">Select</option>
                                                                <option value="single">Single</option>
                                                                <option value="married">Married</option>
                                                            </select>
                                                        </div>

                                                        {formData.marital_status === 'married' && (
                                                            <>
                                                                <div className="col-xl-4">
                                                                    <label htmlFor="spouseName" className="form-label">Spouse Full Name <span className="text-danger">*</span></label>
                                                                    <input type="text" name='spouse_name' className="form-control" id="spouseName" placeholder="Spouse Full Name" value={formData.spouse_name} onChange={handleChange} required />
                                                                </div>
                                                                <div className="col-xl-4">
                                                                    <label htmlFor="spouseContact" className="form-label">Spouse Contact <span className="text-danger">*</span></label>
                                                                    <input type="text" name='spouse_contact' className="form-control" id="spouseContact" placeholder="Spouse Phone Number" value={formData.spouse_contact} onChange={handleChange} required />
                                                                </div>
                                                            </>
                                                        )}

                                                        {formData.marital_status === 'single' && (
                                                            <>
                                                                <div className="col-xl-4">
                                                                    <label htmlFor="nextOfKinName" className="form-label">Next of Kin Full Name <span className="text-danger">*</span></label>
                                                                    <input type="text" name='next_of_kin_name' className="form-control" id="nextOfKinName" placeholder="Full Name" value={formData.next_of_kin_name} onChange={handleChange} required />
                                                                </div>

                                                                <div className="col-xl-4">
                                                                    <label htmlFor="nextOfKinContact" className="form-label">Next of Kin Phone <span className="text-danger">*</span></label>
                                                                    <input type="text" name='next_of_kin_contact' className="form-control" id="nextOfKinContact" placeholder="Phone Number" value={formData.next_of_kin_contact} onChange={handleChange} required />
                                                                </div>
                                                                <div className="col-xl-4">
                                                                    <label htmlFor="nextOfKinRelationship" className="form-label">Relationship <span className="text-danger">*</span></label>
                                                                    <input type="text" name='next_of_kin_relationship' className="form-control" id="nextOfKinRelationship" placeholder="Relationship" value={formData.next_of_kin_relationship} onChange={handleChange} required />
                                                                </div>
                                                                <div className="col-xl-4">
                                                                    <label htmlFor="nextOfKinAddress" className="form-label">Next of Kin Address</label>
                                                                    <textarea className="form-control" name='next_of_kin_address' id="nextOfKinAddress" rows={3} placeholder="Address" value={formData.next_of_kin_address} onChange={handleChange} />
                                                                </div>
                                                            </>
                                                        )}
                                                    </>
                                                )}

                                                <div className="col-xl-4">
                                                    <label htmlFor="workingDays" className="form-label">Working Days/Month</label>
                                                    <select className="form-control" name="working_days_per_month" id="workingDays" value={formData.working_days_per_month} onChange={handleChange}>
                                                        <option value="">Select</option>
                                                        <option value="22">22</option>
                                                        <option value="26">26</option>
                                                    </select>
                                                </div>

                                                <div className="col-xl-4">
                                                    <label htmlFor="workingHours" className="form-label">Working Hours/Day</label>
                                                    <input type="number" name='working_hours_per_day' className="form-control" id="workingHours" placeholder="Hours" value={formData.working_hours_per_day} onChange={handleChange} />
                                                </div>
                                                <div className="col-xl-4">
                                                    <label htmlFor="bankName" className="form-label">Bank Name</label>
                                                    <input type="text" name='bank_name' className="form-control" id="bankName" placeholder="Bank Name" value={formData.bank_name} onChange={handleChange} />
                                                </div>
                                                <div className="col-xl-4">
                                                    <label htmlFor="bankBranch" className="form-label">Bank Branch</label>
                                                    <input type="text" name='bank_branch' className="form-control" id="bankBranch" placeholder="Bank Branch" value={formData.bank_branch} onChange={handleChange} />
                                                </div>
                                                <div className="col-xl-4">
                                                    <label htmlFor="bankAccountNumber" className="form-label">Account Number</label>
                                                    <input type="text" name='bank_account_number' className="form-control" id="bankAccountNumber" placeholder="Account Number" value={formData.bank_account_number} onChange={handleChange} />
                                                </div>
                                                <div className="col-xl-4">
                                                    <label htmlFor="basicSalary" className="form-label">Basic Salary</label>
                                                    <input type="number" name='initial_salary' className="form-control" id="basicSalary" placeholder="Basic Salary" value={formData.initial_salary} onChange={handleChange} />
                                                </div>
                                                <div className="col-xl-4">
                                                    <label htmlFor="vacationLeaveDays" className="form-label">Vacation Leave Days Available</label>
                                                    <input type="text" name='vacation_leave_days' className="form-control" id="vacationLeaveDays" placeholder="Vacation Leave Days Available" value={formData.vacation_leave_days} onChange={handleChange} />
                                                </div>
                                                <div className="col-xl-4">
                                                    <label htmlFor="category" className="form-label">Category</label>
                                                    <select className="form-control" name="category" id="category" value={formData.category} onChange={handleChange}>
                                                        <option value="">Select</option>
                                                        <option value="managerial">Managerial</option>
                                                        <option value="worker">General</option>
                                                    </select>
                                                </div>
                                                <div className="col-xl-4">
                                                    <label htmlFor="role_obj" className="form-label">Role</label>
                                                    <select className="form-control" name="role_obj" id="role_obj" value={formData.role_obj} onChange={handleChange}>
                                                        <option value="">Select Role</option>
                                                        {roles.map(r => (
                                                            <option key={r.id} value={r.id}>{r.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer d-flex gap-2 mt-4">
                                            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                                {isSubmitting ? <BeatLoader color="#ffffff" size={8} /> : 'Create Employee'}
                                            </button>
                                            <button type="button" className="btn btn-danger" onClick={() => navigate('/hr/all-employees')} disabled={isSubmitting}>Cancel</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ImageCropperModal
                isOpen={cropModalOpen}
                imageSrc={rawImageSrc}
                onCropComplete={handleCropComplete}
                onClose={() => setCropModalOpen(false)}
            />
        </div>
    )
}

export default CreateEmployee

